import React from 'react';

/**
 * Shared loading spinner - same visual and size as used in LoadingQuestion
 * so that when transitioning between "restoring room" and "loading question"
 * the spinner stays in the same position.
 * Uses global @keyframes spin from App.css.
 */
export const LOADING_SPINNER_DEFAULT_SIZE = 60;
export const LOADING_SPINNER_DEFAULT_BORDER = 5;

interface LoadingSpinnerProps {
  /** Size in pixels (default 60 to match LoadingQuestion) */
  size?: number;
  /** Border width in pixels (default 5) */
  border?: number;
  /** Optional margin below spinner (e.g. '1.5rem' when followed by title) */
  marginBottom?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = LOADING_SPINNER_DEFAULT_SIZE,
  border = LOADING_SPINNER_DEFAULT_BORDER,
  marginBottom = '1.5rem',
  className,
}) => (
  <div
    className={className}
    style={{
      display: 'inline-block',
      width: `${size}px`,
      height: `${size}px`,
      border: `${border}px solid rgba(255, 193, 7, 0.3)`,
      borderTop: `${border}px solid #FFC107`,
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom,
    }}
    aria-hidden
  />
);

export default LoadingSpinner;
